import { endpoint } from "../../common/constant";
import { fetchAllPostPromisedData } from "../../common/utils/methods/commonMethods/utilityMethod";

export const NEW_EMPTY_ROW = {
  isNew: true,

  status: "ACTIVE",
  subjectDesc: null,
  subjectDispValue: null,
};

export const getSubjects = async (page = 0, pageSize = 50, searchVal = "") => {
  const res = await fetchAllPostPromisedData(
    `${endpoint?.subject.search}?offset=${page}&limit=${pageSize}`,
    { subjectDispVal: searchVal }
  );

  if (res?.code === 200) return res.data;

  return {};
};

export const REGEX_DISP_VAL = /^[A-Za-z0-9 &-]+$/;
